module.exports = __webpack_public_path__ + "img/logo.3ac951e0.png";